const pad = (n: number) => String(n).padStart(2, '0');

export const buildSiteListFilename = (businessCentralId: string, now: Date): string => {
    const safeId = businessCentralId.replace(/[^a-zA-Z0-9._-]/g, '_');
    const date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    const time = `${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
    return `${safeId}-site-list-${date}_${time}.csv`;
};
